import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {SportHomePageContent} from "../../Common/pages/SportHomePageContent";

export default class FormulaOneHomePage extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  render() {
    const { location } = this.props;

    return <SportHomePageContent
      sport="formula-1"
      title="Formula 1 News, Results & Schedule"
      location={ location }
    />
  }
}



// WEBPACK FOOTER //
// ./modules/FormulaOne/containers/FormulaOneHomePage.js